import React from "react";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";

const noKybSubmit = {
  desc: "",
  buttonTxt: " Click here",
  subDesc: " to submit your account details for verification.",
};
const kybSubmit = {
  desc: "Your account verification details are under review. We will update you once verified.",
  buttonTxt: " Click here",
  subDesc: " to check status.",
};
class KybVerificationPopUp extends React.Component {
  render() {
    const { kyb_status = 0, brandName } = this.props;

    const data = kyb_status === 0 ? noKybSubmit : kybSubmit;
    return (
      <Typography.BodySmall color="light" shade="c000" className="mb-0 pb-0">
        {brandName} is only available for verified accounts.
        {data.desc}.{" "}
        <u>
          <Typography.BodySmall
            component="a"
            onClick={(e) => {
              this.props.redirectToSubmitKyb(e);
            }}
          >
            {data.buttonTxt}
          </Typography.BodySmall>
        </u>
        {data.subDesc}
      </Typography.BodySmall>
    );
  }
}

export default KybVerificationPopUp;
